/*
 * Which side of the site this is: the Brazilian one lives under /pt-br
 * (Brazilian exams, Portuguese), everything else is the international one
 * (US, Canada, tech certifications, English). Same server, same database:
 * the API filters by ?region= and the language follows the side unless the
 * visitor's account says otherwise.
 *
 * /pt-br is the router's basename on that side, so every in-app link stays
 * under it without each one knowing.
 */

import { CURRENT_LANG_STORAGE_KEY } from '@/common/constants';
import Storage from '@/utils/storage';

export type Region = 'br' | 'intl';

export const BR_PREFIX = '/pt-br';

const base = process.env.REACT_APP_BASE_URL || '';

const isBrPath = (path: string) =>
  path === `${base}${BR_PREFIX}` || path.startsWith(`${base}${BR_PREFIX}/`);

export const getRegion = (): Region =>
  isBrPath(window.location.pathname) ? 'br' : 'intl';

/** The router basename for this side. */
export const regionBase = () =>
  getRegion() === 'br' ? `${base}${BR_PREFIX}` : base;

export const regionLang = () => (getRegion() === 'br' ? 'pt_BR' : 'en_US');

/** Go to the other side, keeping the page. A language picked on this side
 * stops applying there, so the other side opens in its own language. */
export const switchRegion = (to: Region) => {
  Storage.remove(CURRENT_LANG_STORAGE_KEY);
  const { pathname, search } = window.location;
  const rest = pathname.slice(regionBase().length) || '/';
  window.location.href = `${to === 'br' ? `${base}${BR_PREFIX}` : base}${rest}${search}`;
};
